import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { AiOutlineInstagram, AiOutlinePhone } from 'react-icons/ai'
import { FiFacebook } from 'react-icons/fi'
import { LuTwitter } from 'react-icons/lu'
import { Link } from 'react-router-dom'

const Footer = () => {
    return (
        <div className="dark-bg">
            <Container fluid >
                <Row className="d-flex justify-content-between align-items-center h-60">
                    <Col
                        sm="12"
                        className="d-flex  text-white justify-content-end align-items-center ">
                        <div className="d-flex">
                            <span className="fs-20 me-3">0122455346356</span>
                        </div>
                        <Link to="https://www.facebook.com/" className='text-white'>
                            <FiFacebook className='fs-20 me-3' />
                        </Link>
                        <Link to="https://www.instagram.com/" className="text-white">
                            <AiOutlineInstagram className='fs-20 me-3' />
                        </Link>
                        <Link to="https://twitter.com/home" className="text-white">
                            <LuTwitter className='fs-20' />
                        </Link>
                    </Col>
                </Row>
            </Container>

        </div>
    )
}

export default Footer
